const ActivePolicies = ({ policies }) => {
  const hasPolicies = Array.isArray(policies) && policies.length > 0;

  return (
    <div className="card">
      <div className="card-header">
        <h3 className="card-header-title">Active Policies</h3>
      </div>
      <div className="card-body policies-list">
        {hasPolicies ? (
          policies.map((policy) => (
            <div key={policy.id} className="policy-card">
              <div className="policy-card-header">
                <span className="policy-icon">{policy.icon}</span>
                <span className="policy-type">{policy.type}</span>
                <span className="badge badge--green">{policy.status}</span>
              </div>
              <div className="policy-details">
                <p className="policy-detail-line">
                  {[policy.policyNumber, policy.carrier, policy.premium].filter(Boolean).join(" • ")}
                </p>
                <p className="policy-detail-line">
                  {[policy.expiration ? `Exp: ${policy.expiration}` : null, policy.details].filter(Boolean).join(" • ")}
                </p>
              </div>
            </div>
          ))
        ) : (
          <div className="no-policies-message">
            <span className="no-policies-icon">📄</span>
            <p>No active policies found for this account.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default ActivePolicies;
